import { render, staticRenderFns } from "./LogworkTableHeader.vue?vue&type=template&id=04f33132&scoped=true&"
import script from "./LogworkTableHeader.vue?vue&type=script&lang=js&"
export * from "./LogworkTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./LogworkTableHeader.vue?vue&type=style&index=0&id=04f33132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f33132",
  null
  
)

export default component.exports